<ng-container *transloco="let t">
  <div class="flex h-[50rem] flex-col gap-4">
    <div class="flex justify-end">
      <button iButton size="sm" (click)="openNewUserModal()">
        <IIcon name="plus" />
        {{ "New User" }}
      </button>
    </div>

    <div class="flex flex-1 flex-col gap-2">
      <div iInputGroup>
        <span iInputGroupPrefix><IIcon name="search" /></span>
        <input
          iInputGroupInput
          [ngModel]="''"
          (ngModelChange)="externalFilterChanged($event)"
          [placeholder]="t('manage-authorized-users-modal.search_by_name_or_email')"
          class="w-full"
          size="sm"
          autofocus
        />
      </div>

      <div class="ag-theme-quartz ag-theme-quartz-light flex-1">
        <ag-grid-angular
          [rowData]="gridData()"
          class="h-full"
          [gridOptions]="gridOptions"
          [isExternalFilterPresent]="isExternalFilterPresent"
          [doesExternalFilterPass]="doesExternalFilterPass"
        />
      </div>
    </div>
  </div>
  <ng-template #newUserModal>
    <div class="flex flex-col gap-4">
      @if (isEmailRegistered() === false) {
        <IAlert [title]="t('manage-authorized-access-modal.email_description')" />
      }
      <input
        iInput
        [formControl]="emailControl"
        [placeholder]="t('manage-authorized-users-modal.email_of_the_user_to_invite')"
        size="sm"
        class="w-full"
        autofocus
      />

      <div>
        <div class="mb-2 text-sm font-medium tracking-tight text-gray-700">
          {{ t("manage-authorized-users-modal.access_level") }}
        </div>
        <ISelectMenu class="w-full" [(value)]="accessLevel" fitTriggerWidth>
          <ISelectTrigger class="flex w-full">
            <ISelectValue>
              <div *iSelectValue="let value">{{ value | accessLevelLabel }}</div>
            </ISelectValue>
          </ISelectTrigger>
          <ISelectContent>
            @for (level of accessLevels; track level) {
              <ISelectOption [value]="level">
                {{ level | accessLevelLabel }}
              </ISelectOption>
            }
          </ISelectContent>
        </ISelectMenu>
      </div>

      <div class="flex justify-end gap-2">
        <button iButton variant="secondary" (click)="newUserModalRef?.close()">
          {{ t("common.cancel") }}
        </button>

        <button iButton [disabled]="!emailControl.valid" [loading]="callLoading()" (click)="addNewUser()">
          {{ t("manage-authorized-users-modal.add_user") }}
        </button>
      </div>
    </div>
  </ng-template>
</ng-container>
